export default __webpack_public_path__ + "sentry-illustration.png";